module.exports = __webpack_public_path__ + "img/tutorial_mindWeather_01.ea4ee0ee.jpg";